module.exports = __webpack_public_path__ + "img/23_27.0f43b85b.png";